import axios from 'axios'
import router from '../router/index'
import Message from "element-ui/packages/message/src/main";
// import  MessageBox from  "element-ui/packages/message-box/src/main";

let apiKey = {
  
}
apiKey.title = (title) => {
  title = title || ''
  window.document.title = title
}

//  创建axiox 实例
apiKey.http = axios.create({
  // baseURL: 'https://huanglx-zhinenggui.f.wmeimob.com/school',
  // baseURL:'https://tanggangqiang-zhinenggui.f.wmeimob.com/school',
  // baseURL:'http://school.zhinenggui.t2.wmeimob.cn/school',
    baseURL:'https://inventory.lawkeychem.com/school',
  //  baseURL:'https://lawkeychem.com/school',
  //   baseURL:'https://testschool.lawkeychem.com/school',
  //  baseURL:'http://localhost:16132/school',
  // baseURL:'http://192.168.2.106:16131/school',
  // baseURL:'/wechat',
  timeout: 30000
})
// http request 拦截器
apiKey.http.interceptors.request.use(
  config => {
    // console.log(localStorage.TOKEN)
    let token = localStorage.getItem('TOKEN')
    if (token) {
      config.headers.Authorization = token
    }
    config.headers.Device = 'pc'
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
apiKey.http.interceptors.response.use(
  response => {
    // console.log('response',response)
    if(response.data.code == 418){
      Message({
        message:response.data.description,
        type:'error',
      })
      return response;
    }
    return response
  },
  error => {
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
        //跳转到登陆页面
          router.replace({
            path: '/'
          })
          break;
        case 402:
          // 402 用户未注册跳转注册页面
        //   router.replace({
        //     path: '/login',
        //   })
          break;
        case 403:
        // forbidden
        break;
      }
    }
    // console : Error: Request failed with status code 402
    // return Promise.reject(error.response.message)
    return Promise.reject(error.response)
  })

export default apiKey
